{
  "colorFormat": "Format de culoare",
  "hex": "Hexazecimal",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
